export interface FoxiaApp {
  id: number;
  name?: string | null;
  description?: string | null;
  url?: string | null;
  icon?: string | null;
}

export interface LicensedApp {
  id: number;
  foxia_app_id: number;
  foxia_app?: FoxiaApp | null;
  expires_at?: string | null;
  status?: string;
}

interface LicensedAppsResponse {
  success?: boolean;
  licenses?: LicensedApp[];
  apps?: FoxiaApp[];
  data?: LicensedAppsResponse;
}

function unwrapAppsPayload(body: LicensedAppsResponse): LicensedAppsResponse {
  let payload = body;

  // Foxia ID currently wraps the result as data.data.apps. Keep accepting the
  // previous data.apps and top-level apps/licenses forms during rollout.
  for (let depth = 0; depth < 3; depth += 1) {
    if (Array.isArray(payload.licenses) || Array.isArray(payload.apps) || !payload.data) break;
    payload = payload.data;
  }

  return payload;
}

export async function getLicensedApps(): Promise<LicensedApp[]> {
  const response = await fetch(
    "/api/gateway/me/available-apps",
    {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    },
  );
  if (!response.ok) throw new Error(`Không thể tải danh sách ứng dụng (${response.status})`);

  const body = (await response.json()) as LicensedAppsResponse;
  const payload = unwrapAppsPayload(body);
  if (Array.isArray(payload.licenses)) return payload.licenses;
  return Array.isArray(payload.apps)
    ? payload.apps.map((app) => ({
        id: app.id,
        foxia_app_id: app.id,
        foxia_app: app,
      }))
    : [];
}

export function isSafeAppUrl(value: string | null | undefined): value is string {
  if (!value) return false;
  try {
    const url = new URL(value);
    return url.protocol === "https:" || url.protocol === "http:";
  } catch {
    return false;
  }
}
